import { Injectable, inject } from '@angular/core';

import { NgrxReportsConfiguration } from '@frontend/sports/common/client-config-data-access';
import { Actions, createEffect } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { filter, tap } from 'rxjs';

import { NgrxReportsService } from '../services/ngrx-reports.service';

@Injectable({ providedIn: 'root' })
export class NgrxReportsEffect {
    private actions = inject(Actions);
    private userActions = inject<NgrxReportsService<Action>>(NgrxReportsService);
    private ngrxReportsConfig = inject(NgrxReportsConfiguration);

    handleSaveStateEffect$ = createEffect(
        () => {
            return this.actions.pipe(
                filter((action) => {
                    return (
                        this.ngrxReportsConfig.isReportsEnabled &&
                        !this.ngrxReportsConfig.restrictedActions.some((restrictedAction) => action.type.startsWith(restrictedAction))
                    );
                }),
                tap((action) => {
                    if (action !== null) {
                        this.userActions.addAction(action);
                    }
                }),
            );
        },
        { dispatch: false },
    );
}
